import styles from './index.css';
import html from './index.html';

const TAG_NAME = 'upd-strikethrough';

// TODO: Extract as util
const template = document.createElement('template');
template.innerHTML = `<style>${styles}</style>${html}`;
if (window.ShadyCSS) {
  window.ShadyCSS.prepareTemplate(template, TAG_NAME);
}

export default class Strikethrough extends HTMLElement {
  constructor() {
    super();

    this.shadow = this.attachShadow({ mode: 'open' });
    this.shadow.appendChild(template.content.cloneNode(true));
  }
}

customElements.define(TAG_NAME, Strikethrough);
